import { InviteeStatusEnum } from '../../models/jobInviteeStatusEnum';
import { JobStatusEnum } from '../../models/jobStatusEnum';
import { PoolerUser } from '../../models/user';

export function getPoolerAnsweredTabJobsQuery(_user: PoolerUser): object {
  return {
    status: { $in: [JobStatusEnum.OPEN, JobStatusEnum.CLOSED] },
    invitees: {
      $elemMatch: {
        userId: Meteor.userId(),
        status: {
          $in: [
            InviteeStatusEnum.PARTIAL_AVAILABLE,
            InviteeStatusEnum.AVAILABLE,
            InviteeStatusEnum.UNAVAILABLE,
            InviteeStatusEnum.POSSIBLE_CANDIDATE,
          ],
        },
      },
    },
  };
}
